
export const unitCategories = {
  length: {
    common: ["meter", "kilometer", "centimeter", "mile", "yard", "foot", "inch"],
    maritime: ["nautical mile", "fathom", "cable"],
    "historical european": ["ell", "rod", "furlong", "league"],
    ancient: ["cubit", "roman foot", "span", "palm"]
  },
  weight: {
    common: ["kilogram", "pound", "ounce", "gram", "ton"],
    "precious materials": ["carat", "grain"],
    "historical trade": ["stone", "dram", "talent", "shekel"]
  },
  volume: {
    common: ["liter", "gallon", "cubic meter", "quart", "pint"],
    "historical liquid": ["gill", "hogshead", "firkin", "butt"],
    "historical dry": ["bushel", "peck", "pottle"]
  },
  temperature: {
    modern: ["celsius", "fahrenheit", "kelvin"],
    historical: ["reaumur", "rankine"]
  },
  time: {
    common: ["second", "minute", "hour", "day", "week", "month", "year"],
    historical: ["fortnight", "moment", "jiffy"]
  },
  area: {
    common: ["square meter", "acre", "hectare", "square kilometer", "square mile"],
    historical: ["barn", "morgen", "hide"]
  },
  speed: {
    common: ["meters per second", "miles per hour", "kilometers per hour"],
    maritime: ["knot"],
    historical: ["furlong per fortnight"]
  }
};

// Helper functions
export const getAllUnitsForType = (type: keyof typeof unitCategories): string[] => {
  return Object.values(unitCategories[type]).flat();
};

export const getSubcategoriesForType = (type: keyof typeof unitCategories): string[] => {
  return Object.keys(unitCategories[type]);
};

export const getUnitsForSubcategory = (type: string, subcategory: string): string[] => {
  return unitCategories[type as keyof typeof unitCategories]?.[subcategory] || [];
};
